<template>
  <div>
    <b-modal
        v-model="processModal"
        size="xl"
        hide-footer
        hide-header
        no-close-on-backdrop
        no-close-on-esc
        @shown="addEscListener"
        @hidden="removeEscListener"
      >
      <div class="card card-custom card-stretch">
        <div class="card-header border-0 align-items-center">
          <h3 class="card-title align-items-start flex-column">
            <span class="title font-weight-bold">
              {{ i18n.productionProcess }}
            </span>
          </h3>
          <div class="card-toolbar toolbar-symbol">
            <b-button variant="dark" class="btn-icon rounded-lg" size="sm" @click="closeClick()">
              <i class="la la-close font-size-h5"></i>
            </b-button>
          </div>
        </div>
          <!-- 실적 표 -->
          <v-data-table
            :items="processList"
            item-key="yieldManagementNo"
            class="elevation-1 farm-data-table"
            :no-data-text="`${i18n.noData}`"
            hide-default-footer
            single-expand
            height="490px"
            style="cursor: pointer;"
            :mobile-breakpoint="0"
          >
            <!-- 헤더 -->
            <template v-slot:header>
              <thead class="scrollable-sticky">
                <tr>
                  <th v-for="(header, index) in yieldFirstColumn"
                    :key="index"
                    :rowspan="header.span === 'row' ? header.number : null"
                    :colspan="header.span === 'col' ? header.number : null"
                    :class="['text-center', `sticky-col-${index}`]"
                    :style="index === 0 ? 'width: 100px; min-width: 100px;' : ''"
                  >
                    {{ header.text }}
                  </th>
                </tr>
                <tr>
                  <th v-for="(header, index) in yieldSecondColumn" :key="index" :style="{ width: header.width }" class="text-center">{{ header.text }}</th>
                </tr>
              </thead>
            </template>
            <!-- 바디 -->
            <template v-slot:item="{ item }">
              <tr v-if="item" @click="showPerformanceRegistrationModal(item)">
                <!-- <td>{{ item.workDate }}</td> -->
                <td>{{ item.cropNm }}</td>
                
                <td v-for="(header, index) in yieldSecondColumn" :key="index" :class="header.css" :style="{ width: header.width }">
                  {{ item[header.value] }}
                </td>
              </tr>
              <tr v-else>
                <td colspan="100%" class="text-center">
                  {{ i18n.noData }}
                </td>
              </tr>
            </template>
          </v-data-table>
          <div class="card-footer"> 
            <b-button variant="secondary" size="lg" @click="closeClick()"><span >{{ i18n.close }}</span></b-button>
          </div>
        </div>
      </b-modal>
    </div>
</template>

<script>
  import Vue from "vue";
  import i18n from '@/core/plugins/vue-i18n.js';  
  export default {
    components: {
    },
    props: {
      processModal: Boolean,
      processList : Array
    },
    computed: {
    },
    data() {
      return {
        i18n: {
          close: i18n.t('farm.yield.close'),
          noData: i18n.t('farm.yield.noData'),
          workRegistration : i18n.t('farm.yield.workRegistration'), // 작업 등록
          //
          productionProcess : i18n.t('farm.yield.productionProcess'), // 생산공정
        },
        // 테이블 컬럼명
        yieldFirstColumn: [
          { value: 'cropNm', text: i18n.t('farm.yield.cropNm'), span: 'row', number: 2}, // 작물명
          
          
          
          { value: 'sowing', text: i18n.t('farm.yield.sowing'), span: 'col', number: 4}, // 파종
          { value: 'seedling', text: i18n.t('farm.yield.seedling'), span: 'col', number: 4}, // 육묘
          { value: 'transplant', text: i18n.t('farm.yield.transplant'), span: 'col', number: 5}, // 이식
          { value: 'plant', text: i18n.t('farm.yield.plant'), span: 'col', number: 6}, // 정식
          { value: 'harvest', text: i18n.t('farm.yield.harvest'), span: 'col', number: 13}, // 수확
          
        ],
        yieldSecondColumn: [
          // 파종
          { value: 'workDate', text: i18n.t('farm.yield.sowingDate'),}, // 파종일
          { value: 'usedSowingTray', text: i18n.t('farm.yield.usedSowingTray')}, // 사용 파종판
          { value: 'sowingTotalCapa', text: i18n.t('farm.yield.sowingTotalCapa')}, // 파종 총 Capa
          { value: 'sowingRate', text: i18n.t('farm.yield.sowingRate')}, // 파종율
          // 육묘
          { value: 'seedlingWorkDate', text: i18n.t('farm.yield.seedlingDate')}, // 육묘일
          { value: 'seedlingUsedSeedlingTray', text: i18n.t('farm.yield.usedSeedlingTray')}, // 사용모판
          { value: 'seedlingTotalCapa', text: i18n.t('farm.yield.seedlingTotalCapa')}, // 육묘 총 Capa
          { value: 'germinationRate', text: i18n.t('farm.yield.germinationRate')}, // 발아율
          // 이식
          { value: 'transplantWorkDate', text: i18n.t('farm.yield.transplantDate')}, // 이식일
          { value: 'transplantUsedSeedlingTray', text: i18n.t('farm.yield.usedSeedlingTray')}, // 사용모판
          { value: 'usedTransplantTray', text: i18n.t('farm.yield.usedTransplantTray')}, // 사용이식판
          { value: 'transplantTotalCapa', text: i18n.t('farm.yield.transplantTotalCapa')}, // 이식 총 Capa
          { value: 'transplantRate', text: i18n.t('farm.yield.transplantRate')}, // 이식율
          // 정식
          { value: 'plantWorkDate', text: i18n.t('farm.yield.plantDate')}, // 정식일
          { value: 'plantUsedTransplantTray', text: i18n.t('farm.yield.usedTransplantTray')}, // 사용이식판
          { value: 'usedPlantingTray', text: i18n.t('farm.yield.usedPlantingTray')}, // 사용정식판
          { value: 'plantingTotalCapa', text: i18n.t('farm.yield.plantingTotalCapa')}, // 정식 총 Capa
          { value: 'farmRackNameList', text: i18n.t('farm.yield.plantingArea'), width: '500px', css: 'scrollable-text'}, // 정식 구역
          { value: 'plantingRate', text: i18n.t('farm.yield.plantingRate')}, // 정식율
          // 수확
          { value: 'harvestWorkDate', text: i18n.t('farm.yield.harvestDate')}, // 수확일
          { value: 'cultivationDays', text: i18n.t('farm.yield.cultivationDays')}, // 재배기간
          { value: 'numberOfPlants', text: i18n.t('farm.yield.numberOfPlants')}, // 포기수
          { value: 'rootMaterial', text: i18n.t('farm.yield.rootMaterial')}, // 뿌리원물
          { value: 'weightPerPlant', text: i18n.t('farm.yield.weightPerPlant')}, // 포기당 중량
          { value: 'harvestYield', text: i18n.t('farm.yield.harvestYield')}, // 수확량
          { value: 'targetHarvestYield', text: i18n.t('farm.yield.targetHarvestYield')}, // 목표 수확량
          { value: 'targetWeightPerPlant', text: i18n.t('farm.yield.targetWeightPerPlant')}, // 목표 포기당 중량
          { value: 'excludingHarvestYield', text: i18n.t('farm.yield.excludingHarvestYield')}, // 제외수확량

          { value: 'numberOfDiscards', text: i18n.t('farm.yield.numberOfDiscards')}, // 폐기수
          { value: 'gradeARate', text: i18n.t('farm.yield.gradeARate')}, // A급 비율
          { value: 'discardRate', text: i18n.t('farm.yield.discardRate')}, // 폐기율
          { value: 'achievementRate', text: i18n.t('farm.yield.achievementRate')}, // 달성율
        ],
        
      }
    },
    watch: {
      processModal(newVal) {
        console.log("processModal changed:", newVal);
      }
    },
    created() {
    },
    methods: {
      closeClick() {
        this.$emit('processClose');
      },
      handleEscKey(e) {
        if (e.key === 'Escape') {
          this.closeClick();
        }
      },
      addEscListener() {
        document.addEventListener('keydown', this.handleEscKey);
      },
      removeEscListener() {
        document.removeEventListener('keydown', this.handleEscKey);
      },
    
    },
  }

</script>
<style scoped lang="scss">
  .farm-data-table thead tr:nth-child(1) th:nth-child(1) {
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

// .farm-data-table thead tr:nth-child(1) th:nth-child(2) {
//   border-bottom: 3px solid rgba(0, 0, 0, 0.12);
// }
</style>